export default __webpack_public_path__ + "static/media/united.2de0bb7e.png";